import { BoostSearchProvider } from '../platforms/boost/BoostSearchProvider';
import AppConfig from '../config/config';
/**
 * AQ-1042: production-only swap-in for `./providers.ts` (see
 * webpack.config.js's NormalModuleReplacementPlugin) — `./providers.ts`
 * statically imports all 5 providers for the dev Control Panel, which
 * shipped ~34KB of unused Algolia/Unbxd/Shopify/Mock code into every
 * production bundle. Same exported shape, so callers don't need to change.
 */
export const providerMap = {
    boost: BoostSearchProvider,
};
export function getSearchProvider(providerType, _mockPlatform) {
    const provider = providerType || AppConfig.provider;
    if (provider !== 'boost') {
        throw new Error(`Unsupported provider in production build: "${provider}" — only "boost" is included (see src/search/providers.production.ts).`);
    }
    return new BoostSearchProvider();
}
